import './App.css';
import React, { useState } from 'react';
import Modal from 'react-modal';

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: '900px',
    maxHeight: '90%',
  },
};

function App() {
  const today = new Date();
  const minDate = today.toISOString().split('T')[0];
  const maxDate = new Date(today.getFullYear() + 10, today.getMonth(), today.getDay()).toISOString().split('T')[0];
  const state = {
    button: 1,
    kommune: "",
    behandlingsdato: "",
  };
  const [sucMsg, setSucMsg] = useState("");
  const [errMsg, setErrMsg] = useState("");
  const [isChecked, setIsChecked] = useState(false);
  const [persons, setPersons] = useState([]);
  const [formData, setFormData] = useState({
    navn: '',
    epost: '',
    telefon: '',
    postnr: '',
    kommune: '',
    behandlingsdato: '',
    kommentar: '',
  });
  const [modalIsOpen, setIsOpen] = React.useState(false);
  const terms = document.getElementById("terms-message") ? document.getElementById("terms-message").innerHTML : "";
  const termsTitle = document.getElementById("terms-title") ? document.getElementById("terms-title").innerHTML : "Vilkår";

  const showTerms = () => {
    setIsOpen(true);
  }

  const closeModal = () => {
    setIsOpen(false);
  }

  function clearForm(keepValues = false) {
    setFormData({
      navn: '',
      epost: '',
      telefon: '',
      postnr: '',
      kommune: keepValues ? state.kommune : '',
      behandlingsdato: keepValues ? state.behandlingsdato : '',
      kommentar: '',
    });
  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    setSucMsg("");
    setErrMsg("");

    console.log('Form data:', formData);

    if (state.button === 1) {
      // Meld på
      submitPersons([{ ...formData }]);
    }
    if (state.button === 2) {
      // Legg til
      state.kommune = formData.kommune;
      state.behandlingsdato = formData.behandlingsdato;
      if (persons.length < 20) {
        setPersons([...persons, { ...formData }]);
        clearForm(true);
      }
    }
  };

  function getOderdayFormat(date) {
    var d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2)
      month = '0' + month;
    if (day.length < 2)
      day = '0' + day;

    return [day, month, year].join('.');
  }

  function submitPersons(submittedPersons = null) {
    setSucMsg("");
    setErrMsg("");

    if (!isChecked) {
      setErrMsg("Du må akseptere vilkårene");
      return;
    }

    if (!submittedPersons) {
      submittedPersons = [...persons];
    }

    let subString = ""
    submittedPersons.forEach(p => {
      subString += " > " + p.navn + "\n";
    });

    if (window.confirm("Send bestilling for:\n" + subString)) {
      let orderDay = getOderdayFormat(submittedPersons[0].behandlingsdato);

      let body = "<p>Takk for at du har bestilt time den " + orderDay + ".<br />Jeg kommer tilbake med bekreftelse eller forslag til nytt tidspunkt.<br /><br />Mottatt informasjon:<br /></p>"

      submittedPersons.forEach(data => {
        body += "<ul>";

        Object.entries(data).map(([key, value]) => {
          if (key === "behandlingsdato") {
            value = orderDay;
          }

          body += "<li>";
          body += "<strong>" + key + ": </strong>";
          body += value;
          body += "</li>"
        });

        body += "</ul><br />";
      });

      let email = submittedPersons[0].epost
      let data = { email: email, body: body }

      fetch("/api/form/feedback", {
        method: "POST",
        body: JSON.stringify(data)
      }).then(() => {
        setSucMsg("En mail med bestillingsbekreftelse er sendt til: " + email + ".");
        setPersons([]);
        clearForm();
        setIsChecked(false);
      }).catch(() => {
        setErrMsg("Det oppsto en feil under sending av bestilling.");
      });
    }
  }

  const handleCheckboxChange = (e) => {
    setIsChecked(e.target.checked);
  };

  function editPerson(index) {
    setFormData({ ...persons[index] });
    removePerson(index);
  }

  function removePerson(index) {
    const updatedData = persons.filter((_, i) => i !== index);
    setPersons(updatedData);
  }

  return (
    <div>
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        style={customStyles}
        contentLabel="Terms Modal"
        overlayClassName="ModalOverlay"
      >
        <h2>{termsTitle}</h2>
        <div style={{ maxHeight: '400px', margin: '10px', overflow: 'auto' }} dangerouslySetInnerHTML={{ __html: terms }}></div>
        <button className="btn btn-primary" onClick={closeModal}>Lukk</button>
      </Modal>
      {errMsg !== "" && (
        <div class="alert alert-danger" role="alert">
          <h4 class="alert-heading">Error</h4>
          {errMsg}
        </div>
      )}
      {sucMsg !== "" && (
        <div class="alert alert-success" role="alert">
          <h4 class="alert-heading">Suksess</h4>
          {sucMsg}
        </div>
      )}
      <form onSubmit={handleSubmit}>
        <div className="form-row">
          <div className="form-group col-md-5">
            <label htmlFor="navn">Navn:</label>
            <input
              className="form-control"
              type="text"
              id="navn"
              name="navn"
              maxLength={50}
              value={formData.navn}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group col-md-5">
            <label htmlFor="epost">Epost:</label>
            <input
              className="form-control"
              type="email"
              id="epost"
              name="epost"
              maxLength={70}
              value={formData.epost}
              onChange={handleChange}
              required
            />
          </div>
        </div>
        <div className="form-row">
          <div className="form-group col-md-5">
            <label htmlFor="telefon">Telefon:</label>
            <input
              className="form-control"
              type="tel"
              id="telefon"
              name="telefon"
              maxLength={20}
              value={formData.telefon}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group col-md-5">
            <label htmlFor="postnr">Postnr:</label>
            <input
              className="form-control"
              type="text"
              id="postnr"
              name="postnr"
              maxLength={4}
              value={formData.postnr}
              onChange={handleChange}
              required
            />
          </div>
        </div>
        <div className="form-row">
          <div className="form-group col-md-5">
            <label htmlFor="kommune">Kommune:</label>
            <input
              className="form-control"
              type="text"
              id="kommune"
              name="kommune"
              maxLength={50}
              value={formData.kommune}
              onChange={handleChange}
              disabled={persons.length > 0}
              required
            />
          </div>
          <div className="form-group col-md-5">
            <label htmlFor="behandlingsdato">Ønsket behandlingsdato:</label>
            <input
              className="form-control"
              type="date"
              id="behandlingsdato"
              name="behandlingsdato"
              min={minDate}
              max={maxDate}
              value={formData.behandlingsdato}
              onChange={handleChange}
              disabled={persons.length > 0}
              required
            />
          </div>
        </div>
        <div className="form-row">
          <div className="form-group col-md-5">
            <label htmlFor="kommentar">Kommentar/melding til behandler:</label>
            <textarea
              className="form-control"
              id="kommentar"
              name="kommentar"
              maxLength={255}
              value={formData.kommentar}
              onChange={handleChange}
            ></textarea>
          </div>
        </div>
        <div className="form-row">
          <div className="form-group form-check">
            <input
              type="checkbox"
              className="form-check-input"
              id="termsAndConditions"
              name="termsAndConditions"
              checked={isChecked}
              onChange={handleCheckboxChange}
            ></input>
            <label className="form-check-label" htmlFor="termsAndConditions">Jeg godtar <a href="#" onClick={showTerms}>vilkårene</a></label>
          </div>
        </div>
        {persons.length === 0 && (
          <>
            <button type="submit" className="btn btn-primary" onClick={() => (state.button = 1)}>Send bestilling</button>&nbsp;
          </>
        )}
        {persons.length > 0 && (
          <>
            <button type="button" className="btn btn-primary" onClick={() => submitPersons()}>Send bestilling</button>&nbsp;
          </>
        )}
        <button type="submit" className="btn btn-success" onClick={() => (state.button = 2)}>Legg til</button>
      </form>

      {persons.length > 0 && (
        <div className="mt-3">
          <ul style={{ display: "flex", flexWrap: "wrap", backgroundColor: "rgba(0, 0, 0, 0.8)", padding: "10px 30px" }}>
            {persons.map((data, index) => (
              <li key={index}>
                <strong>{data["navn"]}:</strong>&nbsp;
                <span onClick={() => editPerson(index)} className="btn btn-sm btn-outline-secondary">Rediger</span>&nbsp;
                <span onClick={() => removePerson(index)} className="btn btn-sm btn-outline-danger">Slett</span>
                <ul style={{ minWidth: "250px", maxWidth: "500px", wordBreak: "break-word" }}>
                  {Object.entries(data).map(([key, value]) => {
                    if (key !== 'navn') {
                      return (
                        <li key={key}>
                          <strong>{key}: </strong>
                          {value}
                        </li>
                      );
                    }
                    return null;
                  })}
                </ul>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div >
  );
}

export default App;
